import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Grow } from '@mui/material';
import { useSetAtom } from 'jotai';
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import PersonAddRoundedIcon from '@mui/icons-material/PersonAddRounded';
import { FormProvider, useForm } from 'react-hook-form';
import useAPI from '../../../api';
import { openSnackbarAdviseAtom } from '../../../Atoms';
import CustomDialog from '../../../Components/Dialog/CustomDialog';
import UserDataForm from './UserDataForm';
import keysToLowerCase from '../../../Helpers/keysToLowerCase';

const UserDialog = function UserDialog({
  open = false,
  close = () => {},
  onSubmit = () => {},
  edit = false,
  userData = {},
  roles = [],
  branches = [],
}) {
  const API = useAPI();
  const methods = useForm();
  const intl = useIntl();

  const setOpenSnackbarAdvise = useSetAtom(openSnackbarAdviseAtom);
  const [userBranches, setUserBranches] = useState([]);

  const extensionData = keysToLowerCase(
    JSON.parse(userData?.extensionData || '{}')
  );

  useEffect(() => {
    if (userData !== null)
      methods.reset({
        ...userData,
        extensionData,
        roleId: userData?.roles ? userData?.roles[0]?.roleId : '',
        passwordExpiration: edit ? userData?.passwordExpiration : true,
      });
  }, [userData]);

  useEffect(() => {
    if (!open) {
      methods.reset();
      setUserBranches([]);
    }
  }, [open]);

  useEffect(() => {
    if (edit) {
      API.getUserBranches(
        userData.id, //selected userId
        (res) => {
          setUserBranches(res);
        },
        () => {
          setOpenSnackbarAdvise({
            message: intl.messages.ERROR_LOADING_BRANCHES,
            severity: 'error',
          });
        }
      );
    }
  }, [edit]);

  return (
    <FormProvider {...methods}>
      <CustomDialog
        id="user-management-dialog"
        title={edit ? intl.messages.EDIT_USER : intl.messages.NEW_USER}
        open={open}
        close={(e, reason) => {
          if (reason !== 'backdropClick') {
            close(e, methods.formState.isDirty);
          }
        }}
        maxWidth="md"
        fullWidth
        transition={Grow}
        icon={!edit ? <PersonAddRoundedIcon /> : <ManageAccountsRoundedIcon />}
        onSubmit={onSubmit}
        styles={{
          content: {
            display: 'flex',
            gap: '18px',
          },
        }}
      >
        <UserDataForm
          allBranches={branches}
          formDirty={methods.formState?.isDirty}
          errors={methods.formState?.errors}
          rolesList={roles.map(({ id, activeUsers, licences }) => ({
            value: id,
            activeUsers,
            licences,
          }))}
          edit={edit}
          userBranches={userBranches}
        />
      </CustomDialog>
    </FormProvider>
  );
};

UserDialog.propTypes = {
  open: PropTypes.bool,
  close: PropTypes.func,
  onSubmit: PropTypes.func,
  edit: PropTypes.bool,
  userData: PropTypes.object,
  roles: PropTypes.array,
  branches: PropTypes.array,
};
export default UserDialog;
